export default "__VITE_ASSET__DDjQs_GM__"